import { useEffect, useState } from "react";

// duration 필드(eta·관측 잔여 수명)를 로컬에서 줄이기 위한 시계. enabled 가 꺼지면 인터벌을
// 등록하지 않는다. 그래서 줄일 값이 없는 카드가 주기적으로 다시 렌더링하지 않는다.
export function useNowMs(enabled: boolean, tickMs: number): number {
  const [nowMs, setNowMs] = useState(() => Date.now());
  useEffect(() => {
    if (!enabled) {
      return;
    }
    setNowMs(Date.now());
    const timer = setInterval(() => setNowMs(Date.now()), tickMs);
    return () => clearInterval(timer);
  }, [enabled, tickMs]);
  return nowMs;
}
